export default {
  Model: {},
  Actions: {
    CREATE_REACTION_SUCCESS: 'reactions/CREATE_REACTION_SUCCESS',
    DELETE_REACTION_SUCCESS: 'reactions/DELETE_REACTION_SUCCESS',
  },
  State: {
    REACTIONS_BY_REACTION_SLUG: 'REACTIONS_BY_REACTION_SLUG',
  },
};
